// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--yuz2P","container-vertical":"_93444fe79c--container-vertical--gZD1Z","title":"_93444fe79c--title--OKRno"};